import LoadingMaskCssClass from './const/LoadingMaskCssClass';

function getLoadingMaskElement(element) {
  return Array.from(element.children)
    .find((child) => child.className.indexOf('loading-mask') !== -1);
}

function extractData(value) {
  if (typeof value === 'object') {
    return { loading: value.loading };
  }
  return { loading: value };
}

function makeLoadingMask(labelText) {
  const icon = document.createElement('span');
  icon.className = 'icomoon icomoon-spin icon-spinner2';

  const iconContainer = document.createElement('div');
  iconContainer.className = 'icon-container';
  iconContainer.appendChild(icon);

  const loadingMask = document.createElement('div');
  loadingMask.className = 'loading-mask';
  loadingMask.appendChild(iconContainer);

  if (typeof labelText === 'string') {
    const labelContainer = document.createElement('div');
    labelContainer.className = 'label-container';
    labelContainer.innerHTML = labelText;
    loadingMask.appendChild(labelContainer);
  }

  return loadingMask;
}

function toggleLoadingMask(element, isLoading) {
  const loadingMask = getLoadingMaskElement(element);
  loadingMask.classList.toggle(LoadingMaskCssClass.VISIBLE, isLoading);
}

const LoadingMask = {
  beforeMount(element, binding) {
    const loadingMask = makeLoadingMask(binding.value.text);
    element.appendChild(loadingMask);
    toggleLoadingMask(element, extractData(binding.value).loading);
  },
  updated(element, binding) {
    const { loading } = extractData(binding.value);

    toggleLoadingMask(element, loading);
  },
  unmounted(element) {
    const loadingMask = getLoadingMaskElement(element);
    loadingMask.parentNode.removeChild(loadingMask);
  },
};
export default LoadingMask;
